module.exports = `Единственным предупреждение, которое ты получишь, будет это жуткое далёкое карканье, эхом похоронного звона звучащее во тьме. А когда на тебя уставятся светящиеся красные глаза, бежать будет уже поздно…`
